import styled from 'styled-components';
import { media, customMedia } from 'styles/utils';
import { Button, Paragraph } from 'components';
import { Link } from 'core/routing';

export const MessageWrapper = styled.div`
  position: fixed;
  left: ${props => props.theme.spacing.default};
  bottom: ${props =>
    props.isCn ? props.theme.spacing.xxlarge : props.theme.spacing.default};
  right: ${props => props.theme.spacing.default};
  padding: ${props => props.theme.spacing.default};
  /* TODO: review Z-index values refactoring task */
  z-index: 9999;
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 1px;
  background-color: ${props => props.theme.color.wfGrey};
  /* Media queries */
  ${media.medium`
    display: flex;
    align-items: center;
    /* TODO: fix asymetry, right is being adjusted but not left. */
    // left: ${props => props.theme.spacing.medium};
    right: ${props => props.theme.spacing.medium};
    `}
  left: 64px;
`;

export const ParagraphStyled = styled(Paragraph)`
  color: ${props => props.theme.color.wfWhite};
  /* Media queries */
  ${media.medium`
  margin-right: 3vw;
  `}
`;

export const LinkStyled = styled(Link)`
  color: currentColor;
  text-decoration: underline;
`;

export const ButtonStyled = styled(Button)`
  width: 100%;
  /* Media queries */
  ${customMedia.lessThan('medium')`
    margin: ${props =>
      `${props.theme.spacing.default} 0 ${props.theme.spacing.small}`};
  `}
  ${media.medium`
    width: initial;
  `}
`;
